import React from 'react'

class ContactPage extends React.Component{
  constructor(props){
    super(props)
  }

  render(){
    return(
      <footer id="contact" className="page-footer">
          <div className="container">
            <div className="row">
              <div className="col s12 center-align">
                <h3 className="section-header contact-header">Where to Find Me</h3>
                <h4 className="white-text profile-scale-email"><i className="contact-icon fa fa-envelope-o"></i>lsxliron@gmail.com</h4>
              </div>
              <div className="row contact-icons-row">
                  <div className="col s3 offset-s3 col l2 offset-l4 center-align">
                    <a href="http://github.com/lsxliron" target="_blank"><i className="white-text fa fa-github fa-4x profile-rotating-logo"></i></a>
                  </div>
                  <div className="col s3 col l2 center-align">
                    <a href="http://www.linkedin.com/pub/liron-shimrony/48/427/b7/" target="_blank"><i className="white-text fa fa-linkedin-square fa-4x profile-rotating-logo"></i></a>
                  </div>
                
              </div>
            </div>
          </div>
          <div className="footer-copyright">
            <div className="container-copyright">
            &copy; 2017 Liron Shimrony
            </div>
          </div>
        </footer>
    )
  }
}



export default ContactPage


// WEBPACK FOOTER //
// ./app/components/ContactPage.js